/*!
 * Girlbasket Theme v1.0.0
 * Copyright (c) 2026 Om. All rights reserved.
 *
 * This file is part of the Girlbasket theme, licensed only for use on the
 * Girlbasket store (girlbasket.myshopify.com / girlbasket.com). Copying,
 * modifying, redistributing or reselling this file, in whole or in part,
 * without written permission from Om is prohibited. See LICENSE.md.
 *
 * File: assets/gb-search.js
 */
(() => {
  'use strict';

  const GB = window.GB;
  if (!GB || !GB.events || !GB.settings.predictiveSearch) return;

  /* ---------------------------------------------------------------------
     Predictive search in the header search panel
     --------------------------------------------------------------------- */
  const setup = (panel) => {
    const input = panel.querySelector('.gb-search-form__input');
    const results = panel.querySelector('[data-gb-predictive-results]');
    const suggest = panel.querySelector('.gb-search-panel__suggest');
    if (!input || !results || input.dataset.gbPredictive) return;
    input.dataset.gbPredictive = 'true';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    results.id = results.id || `${panel.id}-results`;
    input.setAttribute('aria-controls', results.id);

    let controller;
    const cache = new Map();

    const show = (html) => {
      results.innerHTML = html;
      const hasContent = html.trim() !== '';
      input.setAttribute('aria-expanded', String(hasContent));
      if (suggest) suggest.hidden = hasContent;
    };

    const search = GB.debounce(async () => {
      const terms = input.value.trim();
      if (!terms) {
        show('');
        return;
      }
      if (cache.has(terms)) {
        show(cache.get(terms));
        return;
      }

      if (controller) controller.abort();
      controller = new AbortController();

      const types = ['product', 'collection', 'query'];
      if (GB.settings.searchPages) types.push('page', 'article');
      const params = new URLSearchParams({
        q: terms,
        section_id: 'gb-predictive-search',
        'resources[type]': types.join(','),
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
        'resources[options][unavailable_products]': 'last'
      });
      if (GB.settings.searchTagsSkus) {
        params.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag,variants.sku');
      }

      panel.classList.add('is-loading');
      try {
        const response = await fetch(`${GB.routes.predictiveSearch}?${params}`, { signal: controller.signal });
        if (!response.ok) throw new Error(response.status);
        const doc = GB.parseHtml(await response.text());
        const html = doc.querySelector('.gb-predictive')?.outerHTML || '';
        cache.set(terms, html);
        if (input.value.trim() === terms) show(html);
      } catch (error) {
        if (error.name !== 'AbortError') show('');
      } finally {
        panel.classList.remove('is-loading');
      }
    }, 250);

    input.addEventListener('input', search);

    // Arrow keys move between results.
    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const items = [...results.querySelectorAll('[data-gb-predictive-item]')];
      if (!items.length) return;
      event.preventDefault();
      const index = items.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = index < items.length - 1 ? items[index + 1] : items[0];
      else next = index > 0 ? items[index - 1] : input;
      next.focus();
    });
  };

  document.querySelectorAll('.gb-search-panel').forEach(setup);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.gb-search-panel').forEach(setup);
  });
})();
